import {setDefaults} from '@/router/helper';

const _import = require('@/libs/util.import.' + process.env.NODE_ENV);


const routes = [
  {
    path: 'tradeScanners',
    name: 'tradeScanners',
    meta: {
      title: '扫码器设置',
    },
    component: _import('manageCenter/tradeScanners.vue'),
  },
  {
    path: 'warehouseList',
    name: 'warehouseList',
    meta: {
      title: '仓库管理',
    },
    component: _import('manageCenter/warehouseList.vue'),
  },
  {
    path: 'proofRoomManage',
    name: 'proofRoomManage',
    meta: {
      title: '打样间管理',
    },
    component: _import('manageCenter/proofRoomManage.vue'),
  },
  {
    path: 'vatInvoiceList',
    name: 'vatInvoiceList',
    meta: {
      title: '进项发票',
    },
    component: _import('manageCenter/vatInvoiceList.vue'),
  },
  {
    path: 'vatInvoice/:invoiceId',
    name: 'vatInvoiceForm',
    meta: {
      title: '进项发票详情',
    },
    component: _import('manageCenter/vatInvoiceForm.vue'),
  },
  {
    path: 'vendorList',
    name: 'vendorList',
    meta: {
      title: '供应商管理',
    },
    component: _import('manageCenter/vendorList.vue'),
  },
  {
    path: 'clientManage',
    name: 'clientManage',
    meta: {
      title: '客户管理',
    },
    component: _import('manageCenter/clientManage.vue'),
  },
  {
    path: 'financialPayment',
    name: 'financialPayment',
    meta: {
      title: '财务付款',
    },
    component: _import('manageCenter/financialPayment.vue'),
  },

  {
    path: 'sampleMaterialList',
    name: 'sampleMaterialList',
    meta: {
      title: '样品管理',
    },
    component: _import('manageCenter/sampleMaterialList.vue'),
  },
  {
    path: 'sampleMaterialForm/:id',
    name: 'sampleMaterialForm',
    meta: {
      title: '样品信息',
    },
    component: _import('manageCenter/sampleMaterialForm.vue'),
  },
  {
    path: 'proofRoundList',
    name: 'proofRoundList',
    meta: {
      title: '打样记录',
    },
    component: _import('manageCenter/proofRoundList.vue'),
  },
  {
    path: 'proofRoundForm/:id',
    name: 'proofRoundForm',
    meta: {
      title: '打样记录',
    },
    component: _import('manageCenter/proofRoundForm.vue'),
  },
  {
    path: 'incidentalList',
    name: 'incidentalList',
    meta: {
      title: '费用管理',
    },
    component: _import('manageCenter/incidentalList.vue'),
  },
  {
    path: 'incidentalForm/:id',
    name: 'incidentalForm',
    meta: {
      title: '费用详情',
    },
    component: _import('manageCenter/incidentalForm.vue'),
  },
  {
    path: 'reconciliationList',
    name: 'reconciliationList',
    meta: {
      title: '对账管理',
    },
    component: _import('manageCenter/reconciliationList.vue'),
  },
  {
    path: 'chargeRecordList',
    name: 'chargeRecordList',
    meta: {
      title: '收款管理',
    },
    component: _import('manageCenter/chargeRecordList.vue'),
  },
  // {
  //   path: 'invoiceList',
  //   name: 'invoiceList',
  //   meta: {
  //     title: '发票详情',
  //   },
  //   component: _import('manageCenter/invoiceList.vue'),
  // },
  {
    path: 'chargeRecordForm/:id',
    name: 'chargeRecordForm',
    meta: {
      title: '应收账详情',
    },
    component: _import('manageCenter/chargeRecordForm.vue'),
  },
  {
    path: 'reconciliationFormAdd',
    name: 'reconciliationFormAdd',
    meta: {
      title: '新建对账',
    },
    component: _import('manageCenter/reconciliationFormAdd.vue'),
  },
  {
    path: 'createChargeRecord',
    name: 'createChargeRecord',
    meta: {
      title: '新建收款',
    },
    component: _import('manageCenter/createChargeRecord.vue'),
  },
  // {
  //   path: 'reconciliationFormView/:id',
  //   name: 'reconciliationFormView',
  //   meta: {
  //     title: '应付款详情old',
  //   },
  //   component: _import('manageCenter/reconciliationFormView.vue'),
  // },
  {
    path: 'paymentIncludeReconForm/:id',
    name: 'paymentIncludeReconForm',
    meta: {
      title: '应付款详情',
    },
    component: _import('manageCenter/paymentIncludeReconForm.vue'),
  },
  {
    // 对账记录.
    path: 'reconciliationFormDtl/:id',
    name: 'reconciliationFormDtl',
    meta: {
      title: '对账详情',
    },
    component: _import('manageCenter/reconciliationFormDtl.vue'),
  },
  {
    path: 'reconciliationPayForm/:id',
    name: 'reconciliationPayForm',
    meta: {
      title: '应付款详情',
    },
    component: _import('manageCenter/reconciliationPayForm.vue'),
  },

  {
    path: 'recon_expect_invoices/:reconId',
    meta: {
      title: '预发票',
    },
    component: _import('manageCenter/reconExpectInvoices.vue'),
  },

  {
    path: 'paymentList',
    name: 'paymentList',
    meta: {
      title: '付款列表',
    },
    component: _import('manageCenter/paymentList.vue'),
  },
  {
    path: 'paymentForm/:id',
    name: 'paymentForm',
    meta: {
      title: '付款详情',
    },
    component: _import('manageCenter/paymentForm.vue'),
  }, {
    path: 'paymentApproveLinkList',
    name: 'paymentApproveLinkList',
    meta: {
      title: '付款审批',
    },
    component: _import('manageCenter/paymentApproveLinkList.vue'),
  },
  {
    path: 'paymentApproveLinkForm/:id',
    name: 'paymentApproveLinkForm',
    meta: {
      title: '结算款审批',
    },
    component: _import('manageCenter/paymentApproveLinkForm.vue'),
  },
  {
    path: 'approval-workflows',
    name: 'approvalWorkflows',
    meta: {
      title: '审批设置',
    },
    component: _import('manageCenter/ApprovalWorkflowSettings.vue'),
  },
  {
    path: 'permit',
    name: 'permit',
    meta: {
      title: '菜单设置',
    },
    component: _import('manageCenter/rolepermit.vue'),
  },
  {
    path: 'census',
    name: 'census',
    meta: {
      title: '统计概况',
    },
    component: _import('manageCenter/census.vue'),
  },
  {
    path:'shipmentDeliveryList',
    name:'shipmentDeliveryList',
    meta:{
      title:'材料发货',
    },
    component: _import('batchShipment/shipmentDeliveryList.vue'),
  },
  {
    path:'shipmentDelivery/:id',
    name:'shipmentDelivery',
    meta:{
      title:'材料发货详情',
    },
    component: _import('batchShipment/shipmentDeliveryBase.vue'),
  },
  {
    path:'shipmentInOutCensus',
    name:'shipmentInOutCensus',
    meta:{
      title:'材料出入库查询',
    },
    component: _import('batchShipment/shipmentInOutCensus.vue'),
  },
  {
    path:'stuffShipmentInReturnCensus',
    name:'stuffShipmentInReturnCensus',
    meta:{
      title:'材料入库查询',
    },
    component: _import('batchShipment/stuffShipmentInReturnCensus.vue'),
  },
  {
    path:'factoryBaseSetting',
    name:'factoryBaseSetting',
    meta:{
      title:'工厂基础设置',
    },
    component: _import('setting/factorySetting.vue'),
  },

];


export default setDefaults(routes);
